import { Navigate } from "react-router-dom";
import { getLandingPath } from "./landing.service";

/**
 * Index route ("/") redirect. A component (not a bare <Navigate>) so the role is
 * read at render time — the route tree is built at module load, before login.
 */
const LandingRedirect = () => (
	<Navigate
		to={getLandingPath()}
		replace
	/>
);

export default LandingRedirect;
